import $ from "jquery";
export function addAbout(about) {
	$('#about').append(`<p>
			${about}
	</p>`);
}